import React from 'react';
import './App.css';
import './css/wallpaper_with_me.css'
import './css/Fonts/GoogleFonts.css'
import './css/wallpaperVideo.css'
import './css/Global.css'





import { 
  Code, 
  House, 
  Wrench, 
  Cpu, 
  Smartphone, 
  ShoppingCart, 
  FlaskConical, 
  CircleDollarSign, 
  Database, 
  PanelsTopLeft 
} from 'lucide-react';
import { CardWork } from './Components/CardWork';
import { CardServices } from './Components/CardServices';
import { CardTech } from './Components/CardTech';

import { CardProjects } from './Components/CardProjects';
import { CardContacts } from './Components/CardContacts';
import { CardWithMe } from './Components/CardWithMe';
import { CardWelcome } from './Components/CardWelcome';
import { CardTitle } from './Components/CardTitle';



function App() {
  return (
    <div className="App pb-16 bg-gray-900 overflow-x-hidden scroll-smooth">
      
      <div className='container-mobile flex flex-col  justify-between  w-full'>

{/*Navbar */}
        <div id='navbar-desktop'  className='fixed w-full z-[100] bg-black backdrop-blur-md shadow-md hidden sm:block h-14 p-3'>
          <div className='flex justify-between pl-6 pr-6 pt-1 pb-1 fontTitle '>
{/*LOGO */}
              
              <div className='FontTitle'>
                <a href="#pageWelcome" target='_self'>
                    <p className='text-white text-2xl'>Jean Wallace</p>
                </a>
              </div>

            
            <div className='hover:text-red-600 text-white hover:cursor-pointer'>
              <span className='flex content-center mt-1 items-center'>
                <a href="https://github.com/JeanWallace01/JeanWallace01" target='_blank'  rel="noreferrer">
                  <p className='fontTitleNavbar'>Github</p>
                </a>
              </span>
            </div>



{/*Grupo de Social*/}
            <div className='flex justify-around gap-x-4 text-white fontTextWeb text-md'>

              <a href='#pageProjects' target='_self' className='flex items-center hover:text-red-600 text-white hover:cursor-pointer'>
                  <p className=' fontTitleNavbar'>Projetos</p>
              </a>

                    <a href='#pageServices' target='_self' className='flex  items-center hover:text-red-600 text-white hover:cursor-pointer'>
                        
                        <p className=' '>Serviços</p>
                    </a >

                        <a href='#pageContacts' target='_self' className='flex  items-center hover:text-red-600 text-white hover:cursor-pointer'>
                            
                            <p className=' '>Contato</p>
                        </a >
            </div>
          </div>
        </div>


{/*Navegação Mobile */}
  <div id='navbar-mobile' className=' bg-black w-full block sm:hidden fixed bottom-0 left-0 z-40 p-1'>
    <div className='flex justify-center gap-x-12 p-1 fontTitle'>
      <a href='#pageWelcome' target='_self' className='flex flex-col gap-1 items-center  hover:text-red-600 text-white hover:cursor-pointer'>
        <House size={15}/>
        <p className='text-xs'>Início</p>
      </a>

       <a href='#pageProjects' target='_self' className='flex flex-col gap-1 items-center  hover:text-red-600 text-white hover:cursor-pointer'>
        <Code size={15}/>
        <p className='text-xs'>Projetos</p>
      </a>


      <a href='#pageServices' target='_self' className='flex flex-col gap-1 items-center  hover:text-red-600 text-white hover:cursor-pointer'>
        <Wrench size={15}/>
        <p className='text-xs'>Serviços</p>
      </a>


      <a href='#pageContacts' target='_self' className='flex flex-col gap-1 items-center  hover:text-red-600 text-white hover:cursor-pointer'>
        <Smartphone size={15}/>
        <p className='text-xs'>Contato</p>
      </a>
    </div>
  </div>
</div>


{/*Welcome*/}
<section id='pageWelcome' className="md:h-[100vh]  p-8">

  <CardWelcome 
    
    text_welcome='Olá meu nome é'
    text_name='Jean Wallace'
    text_work='Desenvolvedor Freelancer / Técnico TI'
    text_describe='Construo experiencias digitais acessiveis e de alta performance. Apaixonado por codigo limpo, design intuitivo e tecnologias modernas.'
  />

</section>



{/*Sobre Mim*/}
<section id='pageWithMe' className="md:h-[100vh]  p-8">
    <CardTitle 
       title='Sobre Mim'
    />

  <CardWithMe 
    part_text_one='Sou um desenvolvedor apaixonado por criar solucoes digitais que fazem a diferenca. Com experiencia em desenvolvimento web full stack, trabalho com tecnologias modernas para construir aplicacoes performaticas e acessiveis.'
    
    part_text_two='Minha jornada na programacao comecou ha alguns anos, quando descobri o poder de transformar ideias em realidade atraves do codigo. Desde entao, venho aprimorando minhas habilidades e explorando novas tecnologias.'

    part_text_three='Atualmente, estou focado em construir produtos web com React, Next.js, TypeScript e Node.js.'
  />

</section>



{/*Experiência*/}
<section id='pageExperience' className="md:h-[110vh]  p-8">
  <CardTitle 
       title='Experiência'
    />

  {/*Divisões*/}
  <div className='md:flex flex-wrap justify-between'>
    <CardWork 
    icon={CircleDollarSign}
    title='SX Negócios'
    text='Atuei no setor de auditoria e qualidade, realizando escutas de formalização e controle de ponto da equipe. Fui responsável pela análise e mudança de roteiros de atendimento, garantindo a conformidade dos processos.'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    data='2023 - 2024'
    position='Jovem Aprendiz'
    />

    <CardWork 
    icon={FlaskConical }
    title='Grupo Quality'
    text='Atuei no suporte técnico aos usuários e na manutenção da infraestrutura de TI da empresa. Minhas principais responsabilidades incluíam a formatação e configuração de máquinas'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    data='2024 - 2025'
    position='Estagiário TI'
    />


    <CardWork 
    icon={ShoppingCart} 
    title='Supermercado Zona Sul '
    text='Responsável pela Microinformática da unidade, atuando na montagem e configuração de Self-Checkouts e manutenção de PDVs e computadores. Realizo a gestão do estoque de equipamentos de TI'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    data='2025 - 2026'
    position='Estagiário TI' 
    />


    <CardWork 
    icon={ShoppingCart}
    title='Supermercado Zona Sul '
    text='Responsável pela Microinformática da unidade, atuando na montagem e configuração de Self-Checkouts e manutenção de PDVs e computadores. Realizo a gestão do estoque de equipamentos de TI'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    data='Atual'
    position='Técnico de Suporte Jr'
    />
    
  </div>
</section>







{/*Serviços*/}
<section id='pageServices' className="md:h-[110vh] mt-5 p-8">
  <CardTitle 
       title='Serviços'
    />

  {/*Divisões*/}
  <div className='md:flex flex-wrap justify-between'>
    
    <CardServices
    icon={Wrench}
    title='Manutenção de Computadores'
    text='Realizo manutenção preventiva e corretiva em desktops e notebooks, garantindo desempenho e durabilidade. Meus serviços incluem diagnóstico de hardware, limpeza interna completa, troca de pasta térmica e upgrades de peças.'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    />


    <CardServices
    icon={Code}
    title='Desenvolvimento Web'
    text='Criação de sites e aplicacoes web modernas, responsivas e otimizadas para performance usando as melhores tecnologias do mercado.'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    />

    <CardServices
    icon={Smartphone}
    title='Desenvolvimento Mobile'
    text='Desenvolvimento de aplicativos mobile multiplataforma com experiencia nativa e interfaces intuitivas.'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    />


    <CardServices
    icon={Database}
    title='Recuperação de Dados'
    text='Organização e salvamento seguro dos seus dados. Realizo a transferência e configuração de backup para garantir que você nunca perca suas informações. Mantenha uma cópia atualizada de tudo o que é essencial para você'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    />



    <CardServices
    icon={Cpu}
    title='Montagem de Computadores'
    text='Realizo manutenção preventiva e corretiva em desktops e notebooks, garantindo desempenho e durabilidade. Meus serviços incluem diagnóstico de hardware, limpeza interna completa, troca de pasta térmica e upgrades de peças.'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    />

    <CardServices
    icon={PanelsTopLeft}
    title='Landing Pages'
    text='Paginas de alta conversao com design atrativo, animacoes suaves e carregamento ultra-rápido.'
    iconBgColor='bg-red-900/30'
    iconColor='text-red-500'
    />

  </div>
</section>


{/*Projetos*/}
<section id='pageProjects'  className='md:h-[140vh] mt-5 p-8 '>

    <CardTitle 
       title='Projetos'
    />

    <CardProjects
    title='TonerFlash'
    text='Desenvolvido inicialmente como projeto acadêmico, o TonerFlash é um sistema focado no controle eficiente de estoque de toners. O software segue ativo em meu roadmap de desenvolvimento, com novas atualizações'
    tech_one='React Native'
    tech_two='SqlLite'
    tech_three='Tailwind'
    githubLink = 'https://github.com/JeanWallace01/TonerFlash'
    />

    <CardProjects 
      title='Grupo Quality'
      text='Criação de um site estratégico para elevar a visibilidade do Grupo Quality. A solução foi projetada para oferecer uma navegação intuitiva, servindo como uma ferramenta chave para captação de leads e apresentação dos serviços da empresa.'
      tech_one='JavaScript'
      tech_two='Tailwind'
      tech_three='SendPulse'
      githubLink=''
      
    />

    <CardProjects 
      title='Gerenciamento Aluno'
      text='Aplicação desenvolvida em Python para consolidar conhecimentos na linguagem e em frameworks de desenvolvimento. O projeto simula rotinas de cadastro e controle acadêmico, servindo como base prática para aplicação de lógica de programação e arquitetura de software'
      tech_one='Python'
      tech_two='Streamlit'
      tech_three='SqlLite'
      githubLink='https://github.com/JeanWallace01/Gerenciamento_Alunos'
    />
</section>








{/*STACKS*/}
<section id='pageHability' className="md:h-[90vh] mt-5 p-8">
  
    <CardTitle 
       title='Habilidades'
    />

  {/*Divisões*/}
  <div className='md:flex flex-wrap justify-between'>
    <CardTech
    
    title='Front End'
    text_one='JavaScript'
    text_two='TypeScript'
    text_three='PHP'
    text_four='Python'
    />

    <CardTech

    title='Backend'
    text_one='PostgreSQL'
    text_two='MySql'
    text_three='SqlLite'
    text_four='Sql'
    />
    <CardTech
    
    title='Ferramentas'
    text_one='Git'
    text_two='Figma'
    text_three='Gimp'
    text_four='Vs Code'
    />

   
  </div>
</section>

{/*CONTACTS*/}

<section id='pageContacts' className="md:h-[50vh] mt-[10%] ml-8 p-8">
  
    <CardTitle 
       title='Contatos'
    />


  <CardContacts 
    title='Vamos Conversar ?'
    text='Estou sempre aberto a novas oportunidades e projetos interessantes. Se voce tem uma ideia ou quer apenas dizer oi, minha caixa de entrada esta sempre aberta.'
    button='Olá'
  />

</section>


    
    </div>
  );
}

export default App;
